import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import TableChartIcon from '@mui/icons-material/TableChart';
import BarChartIcon from '@mui/icons-material/BarChart';
import BubbleChartIcon from '@mui/icons-material/BubbleChart';
import RadarIcon from '@mui/icons-material/Radar';
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';
import DonutSmallIcon from '@mui/icons-material/DonutSmall';
import React from 'react';

export type VizType = 'table' | 'bar' | 'radar' | 'scatter' | 'pie' | 'range';

/** Default visualization for report sections on Reports home. */
export const DEFAULT_REPORT_VIZ: VizType = 'table';

interface VizToggleProps {
    value: VizType;
    options: VizType[];
    onChange: (viz: VizType) => void;
}

const ICONS: Record<VizType, React.ReactNode> = {
    table: <TableChartIcon fontSize="small" />,
    bar: <BarChartIcon fontSize="small" />,
    radar: <RadarIcon fontSize="small" />,
    scatter: <ScatterPlotIcon fontSize="small" />,
    pie: <DonutSmallIcon fontSize="small" />,
    range: <BubbleChartIcon fontSize="small" />,
};

const LABELS: Record<VizType, string> = {
    table: 'Table',
    bar: 'Bar Chart',
    radar: 'Radar',
    scatter: 'Scatter',
    pie: 'Pie',
    range: 'Range',
};

const VizToggle: React.FC<VizToggleProps> = ({ value, options, onChange }) => (
    <ToggleButtonGroup
        value={value}
        exclusive
        onChange={(_, v) => v && onChange(v)}
        size="small"
        sx={{ mb: 2 }}
    >
        {options.map((opt) => (
            <ToggleButton key={opt} value={opt} aria-label={LABELS[opt]}>
                {ICONS[opt]}
            </ToggleButton>
        ))}
    </ToggleButtonGroup>
);

export default VizToggle;
